export class Storage {
    storageUri: string;
    container: string;
    filename: string;
    sasToken: string;
}
